var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImmediateDelivery = function SvgImmediateDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M4.672 4.5h49v7h-49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.899 4.528a.4.4 0 0 0-.4.4v49.145c0 .221.179.4.4.4h48.076a.4.4 0 0 0 0-.8H5.3V11.9h48.345V34a.4.4 0 0 0 .8 0V4.929a.4.4 0 0 0-.4-.4H4.899ZM53.644 11.1V5.328H5.299V11.1h48.345Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.172 45.525h16.026M9.172 49.799h16.026",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.063 21.826V4.928h14.423v16.89a.107.107 0 0 1-.168.088L30.6 17.255a.107.107 0 0 0-.119-.002l-7.254 4.663a.107.107 0 0 1-.165-.09Z",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.738 44.985c0 9.105-7.398 16.485-16.525 16.485-4.86 0-9.229-2.092-12.252-5.422a16.403 16.403 0 0 1-4.273-11.063c0-9.104 7.398-16.485 16.525-16.485 4.463 0 8.514 1.765 11.487 4.634a16.418 16.418 0 0 1 5.038 11.851Z",
    fill: "#EAFFE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.659 42.529v-4.93c0-.055.044-.099.099-.099l1.51.002c.055 0 .1.044.1.099l-.006 4.266c0 .068.066.115.13.094l4.816-1.601a.099.099 0 0 1 .13.093v1.006c0 .042-.027.08-.067.093L51.43 43.23a.099.099 0 0 0-.067.094v1.108c0 .068.067.116.131.093l4.831-1.7a.099.099 0 0 1 .132.093v1.038c0 .042-.027.08-.067.094l-4.96 1.712a.099.099 0 0 0-.067.094v5.461c0 .055.044.1.099.098 3.145-.065 5.607-3.206 5.664-5.993a.1.1 0 0 1 .1-.098h1.738a.1.1 0 0 1 .099.105c-.343 5.777-5.3 8.564-9.306 7.649a.098.098 0 0 1-.076-.095l-.042-6.55a.099.099 0 0 0-.13-.093l-2.837.956a.099.099 0 0 1-.13-.092l-.018-.946c0-.042.026-.08.066-.095l3.004-1.06a.1.1 0 0 0 .066-.094v-1.056a.099.099 0 0 0-.13-.094l-2.9.958a.099.099 0 0 1-.129-.094v-.966c0-.043.027-.08.067-.094l3.025-1.04a.099.099 0 0 0 .067-.094Z",
    fill: "#58B847",
    stroke: "#000",
    strokeWidth: 0.441
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.685 30.694c7.617-4.06 17.148-1.36 21.509 6.192a16.092 16.092 0 0 1 1.688 11.968.4.4 0 0 0 .777.194 16.892 16.892 0 0 0-1.772-12.562c-4.514-7.819-14.31-10.683-22.252-6.667l.758-1.832a.4.4 0 0 0-.74-.306l-1.297 3.138a.4.4 0 0 0 .317.55l3.337.437a.4.4 0 0 0 .104-.794l-2.429-.318ZM59.725 59.224c-7.602 3.992-17.075 1.285-21.419-6.238a16.092 16.092 0 0 1-1.688-11.969.4.4 0 0 0-.777-.193 16.892 16.892 0 0 0 1.772 12.562c4.561 7.9 14.514 10.74 22.497 6.54l-.843 2.039a.4.4 0 1 0 .74.305l1.297-3.138a.4.4 0 0 0-.317-.55l-3.337-.436a.4.4 0 1 0-.104.793l2.18.285Z",
    fill: "#000"
  })));
};
export default SvgImmediateDelivery;